import { Injectable } from '@angular/core';
import { GlobalService } from '../../app/services/global.service';
import { RoleConfig } from '../common/role-config';

@Injectable({ providedIn: 'root' })
export class RoleEvaluatorService {
  constructor(private readonly global: GlobalService) { }

  getActiveRoles(): string[] {
    return [
      this.global.getIsFullAccess && 'fullAccess',
      this.global.getIsApprover && 'approver',
      this.global.getIsReadOnly && 'viewReadOnly',
      this.global.getIsNonAdmin && 'workflowRetrievalManagement',
      this.global.getIsVendorClassificationAccess && 'vendorClassificationOnly',
      this.global.getIsRestrictedVendorClassificationAccess && 'restrictedVendorClassificationAccess',
      this.global.getIsRestrictedVCPCAccess && 'restrictedVCPCAccess',
      this.global.getIsRestrictedPaymentCodeAccess && 'restrictedPaymentCodeAccess',
      this.global.getIsWorkflowRetrievalApproverOnly && 'workflowRetrievalApproverOnly',
      this.global.getIsWorkflowRetrievalVendorClassificationAccess && 'workflowRetrievalVendorClassificationAccess',
      this.global.getIsWorkflowRetrievalAccess && 'workflowRetrievalAccess',
      this.global.getIsApproverVCSubAccess && 'approverVendorClassificationSubstitutionAccess',
      this.global.getIsApproverSubstitutionAccess && 'approverSubstitutionAccess',
      this.global.getIsWorkflowApproverVCSubAccess && 'workflowApproverVCSubstitutionAccess',
      this.global.getIsNonAdminWithRestrictedVCAccess && 'nonAdminWithRestrictedVCAccess'
    ].filter(Boolean) as string[];
  }

  getAllowedRoutes(): string[] {
    const roles = this.getActiveRoles();
    const allRoutes = roles.flatMap(role => RoleConfig[role]?.routes || []);
    return Array.from(new Set(allRoutes));
  }

  getVisibleTabs(): string[] {
    const roles = this.getActiveRoles();
    const allTabs = roles.flatMap(role => RoleConfig[role]?.tabs || []);
    return Array.from(new Set(allTabs));
  }
}
